import { atom } from 'jotai';
import { GroupableGridItem, Instrument, ListedInstrument } from '../../types';
import { Loadable, LoadableState } from '../../utils';

export type OpenPositionItem = {
  id: string;
  /** Termék */
  instrumentBase: Instrument;
  instrument?: ListedInstrument;
  /** Mennyiség */
  position: number;
  /** Bekerulesi árfolyam (átlagár) */
  initValue: number;
  /** Bekerülési érték */
  initPriceValue: number;
  /** Piaci érték initCcy alapján */
  value: number;
  /** Napi P&L */
  pNLDaily?: number;
  /** Összesített P&L */
  pNL?: number;
  /** Összesített százalékos P&L */
  pNLPercentage?: number;
  /** Napi százalékos P&L */
  pNlDailyPercentage?: number;
  note?: string;
  accountId?: string;
  noteModifiedAt?: string;
  currency?: string;
  instrumentName?: string;
  mic?: string;
  /** NOT VISIBLE, used for pNL calculation */
  inventoryDate?: string;
  isMultipleAccountSelected: boolean;
  initCcy: string;
};

export type OpenPositionGridItem = GroupableGridItem<OpenPositionItem>;

export type OpenPositions = {
  positions: Array<OpenPositionGridItem>;
};

export const openPositionsAtom = atom<LoadableState<OpenPositions>>(Loadable.uninitialized);
